import React from 'react';
import { trackWhatsAppClick } from '../analytics';

const Footer = () => (
  <footer className="site-footer">
    <div className="wrap">
      <div className="foot-grid">
        <div>
          <p className="foot-logo">Finca Pescado</p>
          <p style={{ marginTop: 10, maxWidth: '30em' }}>
            Cachama fresca cultivada en Manatí, Atlántico, con entrega a domicilio en Barranquilla y el Atlántico. De la finca a tu casa.
          </p>
        </div>
        <div>
          <h4>Contacto</h4>
          <ul>
            <li>WhatsApp: <a href="https://wa.me/573106846758" target="_blank" rel="noopener noreferrer" onClick={() => trackWhatsAppClick('footer')}>310 684 6758</a></li>
            <li><a href="mailto:Fincapescado811@gmail.com">Fincapescado811@gmail.com</a></li>
            <li>Manatí, Atlántico, Colombia</li>
          </ul>
        </div>
        <div>
          <h4>Síguenos</h4>
          <ul>
            <li><a href="https://www.instagram.com/fincapescado/" target="_blank" rel="noopener noreferrer">Instagram @fincapescado</a></li>
            <li><a href="/#juego">Juegos</a></li>
          </ul>
        </div>
      </div>
      <p className="legal">
        © 2026 Finca Pescado S.A.S · NIT 901.868.384 · Manatí, Atlántico, Colombia · Registro Sanitario INVIMA RSA-3097-2025 · Tabla nutricional certificada por Mediempresa S.A.S · Pescado fresco por kilos con domicilio.
      </p>
    </div>
  </footer>
);

export default Footer;